import { InjectionToken, PLATFORM_ID, inject, REQUEST } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { environment } from '../../../environments/environment';

/**
 * Injection token that resolves to the correct API base URL string.
 * - On the server (SSR):
 *     - In Development: Uses the dev server's incoming request origin (e.g. http://localhost:4200 or 4201)
 *     - In Production: Connects directly to the local Express server on 127.0.0.1 (e.g. http://127.0.0.1:4000)
 * - In the browser: '' (same-origin, relative requests)
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
    providedIn: 'root',
    factory: () => {
        const platformId = inject(PLATFORM_ID);
        if (isPlatformServer(platformId)) {
            const request = inject(REQUEST, { optional: true });

            // 1. Development (ng serve): use the dev server's actual host & port
            if (!environment.production && request?.url) {
                const url = new URL(request.url);
                return `${url.protocol}//${url.host}`;
            }

            // 2. Production: connect directly to local Express instance
            const port = (typeof process !== 'undefined' && process.env?.['PORT']) ? process.env['PORT'] : 4000;
            return `http://127.0.0.1:${port}`;
        }
        return '';
    }
});

export const PLATFORM_API_URL = environment.platformApiUrl;

